import React, { useState, useEffect, useRef } from 'react';
import { Form } from "react-bootstrap";
import { Link, useParams } from "react-router-dom";
import { addPrescription, getPrescription, upatePrescription, upatePrescriptionStatus, addclubfittingdata, getwebhookdata } from "../../Api/prescriptionApis";
import Spinner from 'react-bootstrap/Spinner';
import { getCurrentUser } from "../../Api/auth";
import Modal from 'react-bootstrap/Modal';
import { FaStar } from "react-icons/fa";
import { useHistory } from 'react-router-dom';
import { FaCheck, FaHeart } from "react-icons/fa";
import './LeftScript2.css'
import { getInventoryByType } from "../../Api/inventoryApi";

import { getModeldatabymake } from "../../Api/inventoryApi";
import { IoClose } from "react-icons/io5";
import PrescriptionDataPoints from '../BuildSheet/PrescriptionDataPoints';

export const API_URL = process.env.REACT_APP_API_URL;

const initialPrescriptionState = {
    bounce: '',
    lieage: '',
    shaftweight: '',
    shaftflex: '',
    shaftprofile: '',
    gripSize: '',
    clubLength: '',
    swingWeight: '',

    bounceselect: '',
    lieageselect: '',
    shaftweightselect: '',
    shaftflexselect: '',
    shaftprofileselect: '',
    gripSizeselect: '',
    clubLengthselect: '',
    swingWeightselect: '',

    bouncedropdownselect: '',
    lieagedropdownselect: '',
    shaftweightdropdownselect: '',
    shaftflexdropdownselect: '',
    shaftprofiledropdownselect: '',
    gripSizedropdownselect: '',
    clubLengthdropdownselect: '',
    swingWeightdropdownselect: '',
};


function LeftScript4({ status, project_id, prescriptionid, allMakeData, remortFittingFormData, setRemortFittingFormData, studioshow }) {


    const [head1, setHead1] = useState('');
    const [head2, setHead2] = useState('');
    const [head3, setHead3] = useState('');

    const [Shaft1, setShaft1] = useState('');
    const [Shaft2, setShaft2] = useState('');
    const [Shaft3, setShaft3] = useState('');

    const [Grip1, setGrip1] = useState('');
    const [Grip2, setGrip2] = useState('');
    const [Grip3, setGrip3] = useState('');
    const [remortFittingimages, setRemortFittingImages] = useState([]);

    const [heartdata, setHeartdata] = useState({});

    const [studio_fitting, setStudent_fitting] = useState(true);

    useEffect(() => {
        if (studioshow !== undefined) {
            setStudent_fitting(studioshow);
        }

    }, [studioshow]);

    const history = useHistory();

    const [show03, setShow03] = useState(false);

    const handleClose03 = () => setShow03(false);
    const handleShow03 = () => setShow03(true);

    const [show, setShow] = useState(false);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleChange = (field, value) => {
        setPrescription(prevState => ({
            ...prevState,
            [field]: value
        }));
    };

    useEffect(() => {
        const getCurrentUserdata = getCurrentUser();
        if (getCurrentUserdata && getCurrentUserdata.user) {
            setUserdata(getCurrentUserdata.user);
        } else {
            console.error("Current user data is null or undefined");
        }

    }, []);

    const handleNestedChange = (section, option, subField, value) => {


        var type_id = "";
        if (section === "optimalHeads") {
            type_id = "4";
        }

        if (section === "optimalShafts") {
            type_id = "7";
        }

        if (section === "optimalGrips") {
            type_id = "8";
        }

        const data = {
            make_id: value,
            type_id: type_id
        }
        getModeldatabymake(data).then((response) => {
            console.log("aminesh", 18);
            if (!response.data.status) {
                console.log(response.data.message);
            } else {
                const data = response.data.data;
                if (section === 'optimalHeads' && subField === 'make' && option === 1) {
                    setHead1(data);
                }
                if (section === 'optimalHeads' && subField === 'make' && option === 2) {
                    setHead2(data);
                }
                if (section === 'optimalHeads' && subField === 'make' && option === 3) {
                    setHead3(data);
                }

                if (section === 'optimalShafts' && subField === 'make' && option === 1) {
                    setShaft1(data);
                }
                if (section === 'optimalShafts' && subField === 'make' && option === 2) {
                    setShaft2(data);
                }
                if (section === 'optimalShafts' && subField === 'make' && option === 3) {
                    setShaft3(data);
                }

                if (section === 'optimalGrips' && subField === 'make' && option === 1) {
                    setGrip1(data);
                }
                if (section === 'optimalGrips' && subField === 'make' && option === 2) {
                    setGrip2(data);
                }
                if (section === 'optimalGrips' && subField === 'make' && option === 3) {
                    setGrip3(data);
                }
            }
        }).catch((err) => {
            alert(err);
        })




        setPrescription(prevState => ({
            ...prevState,
            [section]: {
                ...prevState[section],
                [`option${option}`]: {
                    ...(prevState[section] && prevState[section][`option${option}`]),
                    [subField]: value
                }
            }
        }));
    };

    const handlesaveproject = (event) => {

        event.preventDefault();
        const form = event.currentTarget;
        if (form.checkValidity() === false) {
            // event.preventDefault();
            event.stopPropagation();
            handleShow();
        }

        else {
            setApicall(true);
            const data = {
                'prescription': JSON.stringify(prescription),
                'project_id': project_id,
                'user_id': userdata._id,
            }
            addclubfittingdata(data).then((res) => {
                // console.log("res", res);
                if (!res.data.status) {
                    setErrors(res.data.data);
                    alert(res.data.data[0].detail);
                } else {
                    setApicall(false);
                    //getprojectdata();
                    handleShow03();
                    window.scrollTo(0, 0);
                    window.location.reload();
                    // const timer = setTimeout(() => {
                    //     history.push('/project/prescription/prescription-view/' + project_id);  // Change this to the path you want to redirect to
                    // }, 2000);
                }

            }).catch((error) => {
                console.log("error", error);
            });
        }

        setValidated(true);
    }


    const [validated, setValidated] = useState(false);
    const [errors, setErrors] = useState([]);
    const [userdata, setUserdata] = useState('');
    const [imageURL, setImageURL] = useState(null);
    const [imageURL2, setImageURL2] = useState(null);
    const [thumnailURL1, setThumnailURL1] = useState(null);
    const [thumnailURL2, setThumnailURL2] = useState(null);

    const [prescription, setPrescription] = useState(initialPrescriptionState);
    const [fittingid, setfittingid] = useState('');
    const [apicall, setApicall] = useState(false);


    const [makedata, setMakeData] = useState([]);
    const [shaftdata, setShaftData] = useState([]);
    const [gripdata, setGripData] = useState([]);

    const getmakedata = (id) => {
        const data = {
            type_id: id
        }
        const filtermakedata = allMakeData && allMakeData.filter((item) => item.item_type_id.includes(id));
        if (id === 4) {
            setMakeData(filtermakedata);
        }
        if (id === 7) {
            setShaftData(filtermakedata);
        }
        if (id === 8) {
            setGripData(filtermakedata);
        }
    }

    useEffect(() => {
        getmakedata(4);
        getmakedata(7);
        getmakedata(8);
    }, []);

    const handleRadioChange = (field, value) => {
        // setPrescription((prevState) => ({
        //     ...prevState,
        //     [field]: value,
        // }));
    };

    const handleSelectChange = (field, value) => {
        setPrescription((prevState) => ({
            ...prevState,
            [field]: value,
        }));
    };
    // const handlecheckdropdownandinputstatus=(field)=>{
    //   const {value,}
    // }
    const isDropdownDisabled = () => status === "purchased";

    const [swing1, setSwing1] = useState('');
    const [swing2, setSwing2] = useState('');


    useEffect(() => {

        if (remortFittingFormData) {
            // setRemortFittingImages(remortFittingFormData?.remotefittingimage?.remotefittingimage);
            setRemortFittingImages(remortFittingFormData?.remotefittingdata);
            setPrescription(remortFittingFormData?.fittingdata);
            setfittingid(remortFittingFormData?._id)


            const remotefittingdata = remortFittingFormData?.remotefittingdata || {};
            const transformedData = Object.keys(remotefittingdata)
                .filter(key => key !== "step0") // Exclude step0 or any other undesired steps
                .reduce((acc, key) => {
                    acc[key] = { preferred_club: remotefittingdata[key].preferred_club };
                    return acc;
                }, {});

            setHeartdata(remortFittingFormData?.remotefittingdata);
        }

        if (remortFittingFormData) {
            if (remortFittingFormData?.fitting_type === "appfitting") {
                // setImageURL(`${API_URL}${remortFittingFormData?.remotefittingdata?.swingdata?.swing1}`);
                setImageURL(swing1);
                setThumnailURL1(`${API_URL}${remortFittingFormData?.remotefittingdata?.swingdata?.thumbnail1}`);
            } else {
                setImageURL(`${API_URL}remotefittingvideo/${remortFittingFormData?.remotefittingdata?.swingdata?.swing1}`);
                setThumnailURL1(`${API_URL}thumbnails/${remortFittingFormData?.remotefittingdata?.swingdata?.thumbnail1}`);
            }
        } else {
            setImageURL(null);
            setThumnailURL2(null);
        }

        if (remortFittingFormData) {
            if (remortFittingFormData?.fitting_type === "appfitting") {
                // setImageURL2(`${API_URL}${remortFittingFormData?.remotefittingdata?.swingdata?.swing2}`);
                setImageURL2(swing2);
                setThumnailURL2(`${API_URL}${remortFittingFormData?.remotefittingdata?.swingdata?.thumbnail2}`);
            } else {
                setImageURL2(`${API_URL}remotefittingvideo/${remortFittingFormData?.remotefittingdata?.swingdata?.swing2}`);
                setThumnailURL2(`${API_URL}thumbnails/${remortFittingFormData?.remotefittingdata?.swingdata?.thumbnail2}`);
            }
        } else {
            setImageURL2(null);
            setThumnailURL2(null);
        }


    }, [remortFittingFormData])


    const getballdata = () => {
        if (remortFittingFormData) {
            const remotefittingdata = remortFittingFormData.
                remotefittingdata.
                balldata;
            if (remotefittingdata?.type === 'file') {
                window.open(`${API_URL}attachment/${remotefittingdata.value}`, '_blank');
            } else {
                try {
                    const url = remotefittingdata.value.startsWith('http://') || remotefittingdata.value.startsWith('https://')
                        ? remotefittingdata.value
                        : `http://${remotefittingdata.value}`;
                    window.open(url, '_blank');
                } catch (e) {
                    console.error("Invalid URL format", e);

                }
            }
        }
    };

    const [showlightbox, setShowlightbox] = useState(false);
    const [lightboximgSrc, setLightboxImgSrc] = useState('');

    const handleShowLightBox = (src) => {
        setLightboxImgSrc(src);
        setShowlightbox(true);
    };

    const handleCloseLightBox = () => setShowlightbox(false);




    const videoRef = useRef();
    const videoRef2 = useRef();
    const [metadata, setMetadata] = useState({
        duration: null,
        width: null,
        height: null,
        videoUrl: ''
    });

    // Ref to access the video element

    // Event handler for when the video's metadata is loaded
    const handleMetadata = (videoRef) => {
        if (videoRef.current) {
            const video = videoRef.current;

            setMetadata({
                duration: video.duration, // Duration in seconds
                width: video.videoWidth,  // Video width
                height: video.videoHeight, // Video height
                videoUrl: video.currentSrc, // Current video source URL
            });

            // Apply objectFit: 'cover' when the height > width
            // if (video.videoHeight > video.videoWidth) {
            //     video.style.objectFit = 'cover';
            // } else {
            //     video.style.objectFit = 'contain';
            // }
        }
    };

    const imageOptions = [
        {
            label: 'Image 1',
            value: API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron1?.cameraimage?.swing0
        },
        {
            label: 'Image 2',
            value: API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron2?.cameraimage?.swing0
        },
        {
            label: 'Image 3',
            value: API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron3?.cameraimage?.swing0
        }
    ];

    const [appfittingloader, setAppfittingloader] = useState(false);
    const [shotStats, setshotStats] = useState([]);

    useEffect(() => {
        if (remortFittingFormData?.uuid && remortFittingFormData?.fitting_type === "appfitting") {

            setAppfittingloader(true);
            const data = {
                project_id: project_id,
                uuid: remortFittingFormData?.uuid
            };
            getwebhookdata(data)
                .then((res) => {
                    if (!res.data.status) {
                        setErrors(res.data.data);
                        setAppfittingloader(false);
                        alert(res.data.data[0].detail);
                    } else {
                        setAppfittingloader(false);
                        setRemortFittingFormData(prev => ({
                            ...prev,
                            app_data: res.data.shotData,
                        }));
                        setshotStats(res.data.shotStats)
                        setSwing1(res.data.swingVideos[0]?.videoData);
                        setSwing2(res.data.swingVideos[1]?.videoData);

                    }
                })
                .catch((error) => {
                    console.log("error", error);
                });

        }
    }, [remortFittingFormData?.uuid, project_id]);

    return (

        <>
            <Modal
                show={show03}
                // onHide={handleClose03}
                onHide={() => {
                    handleClose03();
                    window.scrollTo(0, 0);
                }}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        Success!
                    </h2>
                    <p className="text-center mb-4">
                        Your data added successfully.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose03}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>

            <Modal
                show={show}
                onHide={handleClose}
                centered
                id="success_tic"
                className='model-thank-you'
            >
                <Modal.Body>
                    <h2 className="text-center mb-3">
                        You missed something!
                    </h2>
                    <p className="text-center mb-4">
                        Please fill out every input field in this section before moving on to the next section.
                    </p>

                    <button type="button" className="btn btn-modal-view" onClick={handleClose}>
                        OK, got it!
                    </button>
                </Modal.Body>
            </Modal>

            <Modal show={showlightbox} onHide={handleCloseLightBox} centered className="header-login-modal">
                <Modal.Body className="modal-body2">
                    <div className="custom-modal-header">
                        <div className="modal-tltle">Image</div>
                        <div className="close-modal">
                            <button type="button" className="btn-close" onClick={handleCloseLightBox} aria-label="Close"> <IoClose /></button>
                        </div>
                    </div>
                    <div className="form-section modal-form-section">
                        <img
                            src={lightboximgSrc}
                            alt="Lightbox"
                            style={{ width: '100%', height: 'auto' }}
                        />
                    </div>
                </Modal.Body>
            </Modal>



            <div className="col-lg-8 col-md-12 col-sm-12 order-md-2 order-sm-2 order-2 dashboard_2 study_guide_open leftscriptnew db_col">

                {
                    remortFittingFormData?.fitting_type !== "appfitting" && (
                        <><div className="black_bg_box padding-fix">
                            <div className="black_bg_box_in ball_data_section d-flex justify-content-between align-items-center">
                                <div className="left_box_ ">
                                    <div className="club-fitting-card">
                                        <div className="gab_title">
                                            <div className="gab_text">
                                                <h5>Ball Data</h5></div>
                                        </div>
                                    </div>
                                </div>

                                <div className="right_box_">
                                    <div className="box_btn">
                                        <button className="open-button" onClick={getballdata}>
                                            Open
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        </>
                    )
                }
                <div className="black_bg_box">
                    <div className="club-fitting-card">
                        {/* <div class="box-step-content admin-box"><div class="box-title"><h4 style={{ color: "white" }}>Watch this to get started</h4></div></div> */}
                        <div className="gab_title ">
                            <div className="collapsed d-flex">
                                <div className="gab_text mt-1 "><h5 className='cf-title'>Golf Swing</h5></div>
                            </div>
                        </div>
                    </div>
                    <br />
                    <div class="col-12 dashboard-se">
                        <div className=" ">
                            <div className="row">
                                <div className="col-md-12">
                                    <div className="d-flex justify-content-center gap-2">
                                        <div className="card-videoo mb-2">
                                            <div className="video-container1">
                                                {imageURL ? (
                                                    <div className="form">
                                                        <video
                                                            playsInline
                                                            ref={videoRef}
                                                            key={imageURL}
                                                            autoPlay
                                                            muted
                                                            style={{
                                                                width: '100%',
                                                                position: 'absolute',
                                                                top: '0',
                                                                left: '0',
                                                                height: '100%',
                                                                borderRadius: '.5rem',
                                                                // objectFit: metadata.width && metadata.height > metadata.width ? 'cover' : 'contain',
                                                            }}
                                                            poster={thumnailURL1 + ''}
                                                            controls
                                                            preload="metadata"
                                                            onLoadedMetadata={() => handleMetadata(videoRef)} // Trigger metadata loading
                                                        >
                                                            {/* <source src={imageURL + ''} type="video/mp4" /> */}
                                                            {
                                                                remortFittingFormData?.fitting_type === "appfitting" ? (
                                                                    <source src={`data:video/mp4;base64,${imageURL}`} type="video/mp4" />
                                                                ) : (
                                                                    <source src={imageURL + ''} type="video/mp4" />
                                                                )
                                                            }
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    </div>
                                                ) : (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                                        zIndex: 2,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderRadius: '.5rem'
                                                    }}>
                                                        <div className="loader"> <Spinner animation="border" variant="success" /></div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        <div className="card-videoo">
                                            <div className="video-container2">
                                                {imageURL2 ? (
                                                    <div className="form">
                                                        <video
                                                            playsInline
                                                            ref={videoRef2}
                                                            key={imageURL2}
                                                            autoPlay
                                                            muted
                                                            style={{
                                                                width: '100%',
                                                                position: 'absolute',
                                                                top: '0',
                                                                left: '0',
                                                                height: '100%',
                                                                borderRadius: '.5rem',
                                                                // objectFit: metadata.width && metadata.height > metadata.width ? 'cover' : 'contain',
                                                            }}
                                                            poster={thumnailURL2 + ''}
                                                            controls
                                                            preload="metadata"
                                                            onLoadedMetadata={() => handleMetadata(videoRef2)} // Trigger metadata loading
                                                        >
                                                            {
                                                                remortFittingFormData?.fitting_type === "appfitting" ? (
                                                                    <source src={`data:video/mp4;base64,${imageURL2}`} type="video/mp4" />
                                                                ) : (
                                                                    <source src={imageURL2 + ''} type="video/mp4" />
                                                                )
                                                            }
                                                            {/* <source src={imageURL2 + ''} type="video/mp4" /> */}
                                                            Your browser does not support the video tag.
                                                        </video>
                                                    </div>
                                                ) : (
                                                    <div style={{
                                                        position: 'absolute',
                                                        top: 0,
                                                        left: 0,
                                                        width: '100%',
                                                        height: '100%',
                                                        backgroundColor: 'rgba(0,0,0,0.5)',
                                                        zIndex: 2,
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        justifyContent: 'center',
                                                        borderRadius: '.5rem'
                                                    }}>
                                                        <div className="loader"> <Spinner animation="border" variant="success" /></div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <Form noValidate validated={validated} onSubmit={handlesaveproject}
                // style={{
                // pointerEvents : SinglePrescription === 0 ? 'auto' : 'none'
                // }}
                >
                    <div className="listing-box">
                        <div className="black_bg_box" style={{ border: '4px solid #ffffff' }}>
                            <div className="club-fitting-card">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>White</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.bounce && prescription?.bouncedropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>

                            </div>


                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (<div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>
                                        {/* First Image */}
                                        <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                            {studio_fitting ? (
                                                <div className="image-placeholder">
                                                    <h3 className="placeholder-text">1</h3>
                                                </div>
                                            ) : (
                                                <div className="image-box">
                                                    <img
                                                        src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.whiteiron?.iron1?.cameraimage?.swing0}
                                                        onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.whiteiron?.iron1?.cameraimage?.swing0)}
                                                        alt="img"
                                                        className="square-image"
                                                    />
                                                </div>
                                            )}
                                            <div className="heart-container">
                                                <FaHeart
                                                    color={heartdata?.irondata?.whiteiron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                    className="heart-icon"
                                                />
                                            </div>
                                        </div>

                                        {/* Second Image */}
                                        <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                            {studio_fitting ? (
                                                <div className="image-placeholder">
                                                    <h3 className="placeholder-text">2</h3>
                                                </div>
                                            ) : (
                                                <div className="image-box">
                                                    <img
                                                        src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.whiteiron?.iron2?.cameraimage?.swing0}
                                                        onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.whiteiron?.iron2?.cameraimage?.swing0)}
                                                        alt="img"
                                                        className="square-image"
                                                    />
                                                </div>
                                            )}
                                            <div className="heart-container">
                                                <FaHeart
                                                    color={heartdata?.irondata?.whiteiron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                    className="heart-icon"
                                                />
                                            </div>
                                        </div>

                                        {/* Third Image */}
                                        <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                            {studio_fitting ? (
                                                <div className="image-placeholder">
                                                    <h3 className="placeholder-text">3</h3>
                                                </div>
                                            ) : (
                                                <div className="image-box">
                                                    <img
                                                        src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.whiteiron?.iron3?.cameraimage?.swing0}
                                                        onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.whiteiron?.iron3?.cameraimage?.swing0)}
                                                        alt="img"
                                                        className="square-image"
                                                    />
                                                </div>
                                            )}
                                            <div className="heart-container">
                                                <FaHeart
                                                    color={heartdata?.irondata?.whiteiron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                    className="heart-icon"
                                                />
                                            </div>
                                        </div>
                                    </div>)
                                }


                                {
                                    remortFittingFormData?.fitting_type === "appfitting" ? (
                                        <div className="row default-row">
                                            <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                                <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                    <h3 className="d-flex mb-0" style={{ color: "#ffffff" }}>Bounce</h3>
                                                </div>
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                        value={prescription?.bouncedropdownselect} required
                                                        disabled={isDropdownDisabled()}
                                                        onChange={(e) => handleSelectChange('bouncedropdownselect', e.target.value)}>
                                                        <option value={""}>Select Bounce</option>
                                                        <option value="1">Low Bounce</option>
                                                        <option value="2">Mid Bounce</option>
                                                        <option value="3">High Bounce</option>
                                                    </select>
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select a Dexterity
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                            {/* Label column */}
                                            <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                                {/* Dropdown select column */}
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select
                                                        disabled={isDropdownDisabled()} // Disable condition
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Image select dropdown"
                                                    >
                                                        <option value="">Select Preferred</option>
                                                        {/* Map over image options to populate dropdown */}
                                                        {imageOptions.map((option, index) => (
                                                            <option key={index} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Validation feedback */}
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select an image
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>

                                            <style>
                                                {`
                                                @media screen and (min-width: 992px) and (max-width: 1440px){
                                                    .default-row{
                                                        display: flex;
                                                        flex-direction: column;
                                                    }
                                                    .default-row .col-md-6{
                                                        width: 100%;
                                                    }
                                                }
                                                `}
                                            </style>
                                        </div>
                                    ) : (<div className="row gx-2">
                                        <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                            <h3 style={{ color: "#ffffff" }}>Bounce</h3>
                                        </div>
                                        <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                value={prescription?.bouncedropdownselect} required
                                                disabled={isDropdownDisabled()}
                                                onChange={(e) => handleSelectChange('bouncedropdownselect', e.target.value)}>
                                                <option value={""}>Select Bounce</option>
                                                <option value="1">Low Bounce</option>
                                                <option value="2">Mid Bounce</option>
                                                <option value="3">High Bounce</option>
                                            </select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Dexterity
                                            </Form.Control.Feedback>
                                        </div>
                                    </div>
                                    )
                                }
                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" value={prescription?.bounce} onChange={(e) => handleChange('bounce', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add your bounce notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid bounce.
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="White" appdata={remortFittingFormData?.app_data?.White} imageURL={imageURL} shotStats={shotStats} />)
                        }

                        <div className="black_bg_box mt-0" style={{ border: '4px solid #000000' }}>
                            <div className="club-fitting-card black_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Black</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.lieage && prescription?.lieagedropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (
                                        <div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>
                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? (
                                                        <div className="image-placeholder">
                                                            <h3 className="placeholder-text">1</h3>
                                                        </div>
                                                    )
                                                        :
                                                        (
                                                            <div className='image-box'>
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blackiron?.iron1?.cameraimage?.swing0}
                                                                    alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blackiron?.iron1?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.blackiron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? (<div className="image-placeholder">
                                                        <h3 className="placeholder-text">2</h3>
                                                    </div>)
                                                        :
                                                        (
                                                            <div className='image-box'>
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blackiron?.iron2?.cameraimage?.swing0}
                                                                    alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blackiron?.iron2?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.blackiron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? (<div className="image-placeholder">
                                                        <h3 className="placeholder-text">3</h3>
                                                    </div>)
                                                        :
                                                        (
                                                            <div className='image-box'>
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blackiron?.iron3?.cameraimage?.swing0}
                                                                    alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blackiron?.iron3?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.blackiron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>
                                        </div>)
                                }


                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" ? (
                                        <div className="row gx-2">
                                            <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff" }}>Lie Angle</h3>
                                            </div>
                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.lieagedropdownselect} required
                                                    disabled={isDropdownDisabled()}
                                                    onChange={(e) => handleSelectChange('lieagedropdownselect', e.target.value)}>
                                                    <option value={""}>Select Lie Angle</option>
                                                    <option value="1">Upright</option>
                                                    <option value="2">Standard</option>
                                                    <option value="3">Flat</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Dexterity
                                                </Form.Control.Feedback>
                                            </div>

                                        </div>
                                    ) : (
                                        <div className="row default-row">
                                            <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                                <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                    <h3 className="d-flex mb-0" style={{ color: "#ffffff", minWidth: "max-content" }}>Lie Angle</h3>
                                                </div>
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select disabled={isDropdownDisabled()} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                        value={prescription?.lieagedropdownselect} required
                                                        onChange={(e) => handleSelectChange('lieagedropdownselect', e.target.value)}>
                                                        <option value={""}>Select Lie Angle</option>
                                                        <option value="1">Upright</option>
                                                        <option value="2">Standard</option>
                                                        <option value="3">Flat</option>
                                                    </select>
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select a Dexterity
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                            {/* Label column */}
                                            <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                                {/* Dropdown select column */}
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select
                                                        disabled={isDropdownDisabled()} // Disable condition
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Image select dropdown"
                                                    >
                                                        <option value="">Select Preferred</option>
                                                        {/* Map over image options to populate dropdown */}
                                                        {imageOptions.map((option, index) => (
                                                            <option key={index} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Validation feedback */}
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select an image
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" value={prescription?.lieage} onChange={(e) => handleChange('lieage', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add lie angle notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid lie angle.
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="Black" appdata={remortFittingFormData?.app_data?.Black} imageURL={imageURL} shotStats={shotStats} />)
                        }

                        {/* Blue Box */}
                        <div className="black_bg_box mt-0" style={{ border: '4px solid #033df8' }}>
                            <div className="club-fitting-card blue_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Blue</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.shaftweight && prescription?.shaftweightdropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (
                                        <div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? (<div className="image-placeholder">
                                                        <h3 className="placeholder-text">1</h3>
                                                    </div>)
                                                        :
                                                        (
                                                            <div className='image-box'>
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blueiron?.iron1?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blueiron?.iron1?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.blueiron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? (<div className="image-placeholder">
                                                        <h3 className="placeholder-text">2</h3>
                                                    </div>)
                                                        :
                                                        (
                                                            <div className='image-box'>
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blueiron?.iron2?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blueiron?.iron2?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.blueiron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? (<div className="image-placeholder">
                                                        <h3 className="placeholder-text">3</h3>
                                                    </div>)
                                                        :
                                                        (
                                                            <div className='image-box'>
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blueiron?.iron3?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.blueiron?.iron3?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.blueiron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>
                                        </div>)
                                }


                                {
                                    remortFittingFormData?.fitting_type === "appfitting" ? (
                                        <div className="row default-row">
                                            <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                                <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                    <h3 className="d-flex mb-0" style={{ color: "#ffffff", minWidth: "max-content" }}>Shaft Weight</h3>
                                                </div>
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                        value={prescription?.shaftweightselect} required
                                                        disabled={isDropdownDisabled()}
                                                        onChange={(e) => handleSelectChange('shaftweightselect', e.target.value)}>
                                                        <option value={""}>Select Shaft Weight</option>
                                                        <option value="1">Heavy</option>
                                                        <option value="2">Medium</option>
                                                        <option value="3">Light</option>
                                                    </select>
                                                </div>
                                            </div>
                                            {/* Label column */}
                                            <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                                {/* Dropdown select column */}
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select
                                                        disabled={isDropdownDisabled()} // Disable condition
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Image select dropdown"
                                                    >
                                                        <option value="">Select Preferred</option>
                                                        {/* Map over image options to populate dropdown */}
                                                        {imageOptions.map((option, index) => (
                                                            <option key={index} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Validation feedback */}
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select an image
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row gx-2">
                                            <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff" }}>Shaft Weight</h3>
                                            </div>
                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.shaftweightdropdownselect} required
                                                    disabled={isDropdownDisabled()}
                                                    onChange={(e) => handleSelectChange('shaftweightdropdownselect', e.target.value)}>
                                                    <option value={""}>Select Shaft Weight</option>
                                                    <option value="1">Heavy</option>
                                                    <option value="2">Medium</option>
                                                    <option value="3">Light</option>
                                                </select>
                                            </div>

                                        </div>
                                    )
                                }
                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" value={prescription?.shaftweight} onChange={(e) => handleChange('shaftweight', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add shaft weight notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid shaft weight.
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="Blue" appdata={remortFittingFormData?.app_data?.Blue} imageURL={imageURL} shotStats={shotStats} />)
                        }

                        {/* Pink */}
                        <div className="black_bg_box mt-0" style={{ border: '4px solid #f73aec' }}>
                            <div className="club-fitting-card pink_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Pink</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.shaftflex && prescription?.shaftflexdropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (
                                        <div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>
                                            {/* First Image */}
                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">1</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.pinkiron?.iron1?.cameraimage?.swing0}
                                                                    alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.pinkiron?.iron1?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.pinkiron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            {/* Second Image */}
                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">2</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.pinkiron?.iron2?.cameraimage?.swing0}
                                                                    alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.pinkiron?.iron2?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.pinkiron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            {/* Third Image */}
                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">3</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.pinkiron?.iron3?.cameraimage?.swing0}
                                                                    alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.pinkiron?.iron3?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )
                                                }
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.pinkiron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    remortFittingFormData?.fitting_type === "appfitting" ? (
                                        <div className="row default-row">
                                            <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                                <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                    <h3 className="d-flex mb-0" style={{ color: "#ffffff", minWidth: "max-content" }}>Shaft Flex</h3>
                                                </div>
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select disabled={isDropdownDisabled()} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                        value={prescription?.shaftflexdropdownselect} required
                                                        onChange={(e) => handleSelectChange('shaftflexdropdownselect', e.target.value)}>
                                                        <option value={""}>Select Shaft Flex</option>
                                                        <option value="1">Hard</option>
                                                        <option value="2">Medium</option>
                                                        <option value="3">Soft</option>
                                                    </select>
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select a Shaft Flex
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                            {/* Label column */}
                                            <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                                {/* Dropdown select column */}
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select
                                                        disabled={isDropdownDisabled()} // Disable condition
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Image select dropdown"
                                                    >
                                                        <option value="">Select Preferred</option>
                                                        {/* Map over image options to populate dropdown */}
                                                        {imageOptions.map((option, index) => (
                                                            <option key={index} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Validation feedback */}
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select an image
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                        </div>
                                    ) : (
                                        <div className="row gx-2">
                                            <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff" }}>Shaft Flex</h3>
                                            </div>
                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.shaftflexdropdownselect} required
                                                    disabled={isDropdownDisabled()}
                                                    onChange={(e) => handleSelectChange('shaftflexdropdownselect', e.target.value)}>
                                                    <option value={""}>Select Shaft Flex</option>
                                                    <option value="1">Hard</option>
                                                    <option value="2">Medium</option>
                                                    <option value="3">Soft</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Shaft Flex
                                                </Form.Control.Feedback>
                                            </div>

                                        </div>
                                    )
                                }
                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription?.shaftflex} onChange={(e) => handleChange('shaftflex', e.target.value)} rows="10" placeholder="Add shaft flex notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid shaft flex.
                                </Form.Control.Feedback>
                            </div>
                        </div>


                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="Pink" appdata={remortFittingFormData?.app_data?.Pink} imageURL={imageURL} shotStats={shotStats} />)
                        }

                        {/* Purple */}
                        <div className="black_bg_box mt-0" style={{ border: '4px solid #9d02d6' }}>
                            <div className="club-fitting-card purple_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Purple</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.shaftprofile && prescription?.shaftprofiledropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (
                                        <div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>
                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">1</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.purpleiron?.iron1?.cameraimage?.swing0}
                                                                    alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.purpleiron?.iron1?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.purpleiron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">2</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.purpleiron?.iron2?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.purpleiron?.iron2?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.purpleiron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">3</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.purpleiron?.iron3?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.purpleiron?.iron3?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.purpleiron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }
                                {
                                    remortFittingFormData?.fitting_type === "appfitting" ? (<div className="row default-row">
                                        <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                            <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                <h3 className="d-flex mb-0" style={{ color: "#ffffff", minWidth: "max-content" }}>Shaft Profile</h3>
                                            </div>
                                            <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                <select disabled={isDropdownDisabled()} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.shaftprofiledropdownselect} required
                                                    onChange={(e) => handleSelectChange('shaftprofiledropdownselect', e.target.value)}>
                                                    <option value={""}>Select Shaft Profile</option>
                                                    <option value="1">Firm Tip</option>
                                                    <option value="2">Soft Mid</option>
                                                    <option value="3">Firm Butt</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Dexterity
                                                </Form.Control.Feedback>
                                            </div>
                                        </div>
                                        {/* Label column */}
                                        <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                            <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                            {/* Dropdown select column */}
                                            <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                <select
                                                    disabled={isDropdownDisabled()} // Disable condition
                                                    className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Image select dropdown"
                                                >
                                                    <option value="">Select Preferred</option>
                                                    {/* Map over image options to populate dropdown */}
                                                    {imageOptions.map((option, index) => (
                                                        <option key={index} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Validation feedback */}
                                                <Form.Control.Feedback type="invalid">
                                                    Please select an image
                                                </Form.Control.Feedback>
                                            </div>
                                        </div>
                                    </div>) : (
                                        <div className="row gx-2">
                                            <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff" }}>Shaft Profile</h3>
                                            </div>
                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.shaftprofiledropdownselect} required
                                                    disabled={isDropdownDisabled()}
                                                    onChange={(e) => handleSelectChange('shaftprofiledropdownselect', e.target.value)}>
                                                    <option value={""}>Select Shaft Profile</option>
                                                    <option value="1">Firm Tip</option>
                                                    <option value="2">Soft Mid</option>
                                                    <option value="3">Firm Butt</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Dexterity
                                                </Form.Control.Feedback>
                                            </div>

                                        </div>
                                    )
                                }

                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" value={prescription?.shaftprofile} onChange={(e) => handleChange('shaftprofile', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add shaft profile notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid shaft profile.
                                </Form.Control.Feedback>
                            </div>
                        </div >

                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="Purple" appdata={remortFittingFormData?.app_data?.Purple} imageURL={imageURL} shotStats={shotStats} />)
                        }


                        {/* Red */}
                        <div className="black_bg_box mt-0" style={{ border: '4px solid #f1030e' }}>
                            <div className="club-fitting-card red_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Red</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.gripSize && prescription?.gripSizedropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (
                                        <div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">1</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.rediron?.iron1?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.rediron?.iron1?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.rediron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">2</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.rediron?.iron2?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.rediron?.iron2?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.rediron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">3</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.rediron?.iron3?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.rediron?.iron3?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.rediron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )
                                }

                                {
                                    remortFittingFormData?.fitting_type === "appfitting" ? (
                                        <div className="row default-row">
                                            <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                                <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                    <h3 className="d-flex mb-0" style={{ color: "#ffffff", minWidth: "max-content" }}>Grip Size</h3>
                                                </div>
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select disabled={isDropdownDisabled()} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                        value={prescription?.gripSizedropdownselect} required
                                                        onChange={(e) => handleSelectChange('gripSizedropdownselect', e.target.value)}>
                                                        <option value={""}>Select Grip Size</option>
                                                        <option value="1">Oversize</option>
                                                        <option value="2">Mid</option>
                                                        <option value="3">Standard</option>
                                                    </select>
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select a Dexterity
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>


                                            {/* Label column */}
                                            <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                                {/* Dropdown select column */}
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select
                                                        disabled={isDropdownDisabled()} // Disable condition
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Image select dropdown"
                                                    >
                                                        <option value="">Select Preferred</option>
                                                        {/* Map over image options to populate dropdown */}
                                                        {imageOptions.map((option, index) => (
                                                            <option key={index} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Validation feedback */}
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select an image
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                        </div>) : (<div className="row gx-2">
                                            <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff" }}>Grip Size</h3>
                                            </div>
                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.gripSizedropdownselect} required
                                                    disabled={isDropdownDisabled()}
                                                    onChange={(e) => handleSelectChange('gripSizedropdownselect', e.target.value)}>
                                                    <option value={""}>Select Grip Size</option>
                                                    <option value="1">Oversize</option>
                                                    <option value="2">Mid</option>
                                                    <option value="3">Standard</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Dexterity
                                                </Form.Control.Feedback>
                                            </div>

                                        </div>
                                    )
                                }
                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" value={prescription?.gripSize} onChange={(e) => handleChange('gripSize', e.target.value)} id="exampleFormControlTextarea1" rows="10" placeholder="Add grip size notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid grip size.
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="Red" appdata={remortFittingFormData?.app_data?.Red} imageURL={imageURL} shotStats={shotStats} />)
                        }

                        {/* Orange */}
                        <div className="black_bg_box mt-0" style={{ border: '4px solid #e58700' }}>
                            <div className="club-fitting-card orange_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Orange</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.clubLength && prescription?.clubLengthdropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (
                                        <div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>
                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">1</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron1?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron1?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.orangeiron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>


                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">2</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron2?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron2?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.orangeiron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">3</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img
                                                                    src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron3?.cameraimage?.swing0}
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.orangeiron?.iron3?.cameraimage?.swing0)}
                                                                    alt="img"
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.orangeiron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                {
                                    remortFittingFormData?.fitting_type === "appfitting" ? (
                                        <div className="row default-row">
                                            <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                                <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                    <h3 className="d-flex mb-0" style={{ color: "#ffffff", minWidth: "max-content" }}>Club Length</h3>
                                                </div>
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select disabled={isDropdownDisabled()} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                        value={prescription?.clubLengthdropdownselect} required
                                                        onChange={(e) => handleSelectChange('clubLengthdropdownselect', e.target.value)}>
                                                        <option value={""}>Select Club Length</option>
                                                        <option value="1">Long</option>
                                                        <option value="2">Medium</option>
                                                        <option value="3">Short</option>
                                                    </select>
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select a Dexterity
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>

                                            {/* Label column */}
                                            <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                                {/* Dropdown select column */}
                                                <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                    <select
                                                        disabled={isDropdownDisabled()}
                                                        className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                        aria-label="Image select dropdown"
                                                    >
                                                        <option value="">Select Preferred</option>
                                                        {/* Map over image options to populate dropdown */}
                                                        {imageOptions.map((option, index) => (
                                                            <option key={index} value={option.value}>
                                                                {option.label}
                                                            </option>
                                                        ))}
                                                    </select>

                                                    {/* Validation feedback */}
                                                    <Form.Control.Feedback type="invalid">
                                                        Please select an image
                                                    </Form.Control.Feedback>
                                                </div>
                                            </div>
                                        </div>) : (<div className="row gx-2">
                                            <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                                <h3 style={{ color: "#ffffff" }}>Club Length</h3>
                                            </div>
                                            <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                                <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.clubLengthdropdownselect}
                                                    disabled={isDropdownDisabled()}
                                                    onChange={(e) => handleSelectChange('clubLengthdropdownselect', e.target.value)}>
                                                    <option value={""}>Select Club Length</option>
                                                    <option value="1">Long</option>
                                                    <option value="2">Medium</option>
                                                    <option value="3">Short</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Dexterity
                                                </Form.Control.Feedback>
                                            </div>

                                        </div>
                                    )}
                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription?.clubLength} onChange={(e) => handleChange('clubLength', e.target.value)} rows="10" placeholder="Add club length notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid club length.
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="Orange" appdata={remortFittingFormData?.app_data?.Orange} imageURL={imageURL} shotStats={shotStats} />)
                        }

                        {/* Green Box */}
                        <div className="black_bg_box mt-0" style={{ border: '4px solid #82bf2a' }}>
                            <div className="club-fitting-card green_box">
                                <div className="gab_title">
                                    <div class="gab_text"><h5><span class="color"></span>Green</h5></div>
                                    <div className="collapsed">
                                        <div className={`head_check ${prescription && prescription?.swingWeight && prescription?.swingWeightdropdownselect ? 'active' : ''}`}>
                                            <FaCheck />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="form-group prescription-note">
                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" && (
                                        <div className="image-row-container row d-flex justify-content-around" style={{ flexWrap: 'nowrap' }}>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">1</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.greeniron?.iron1?.cameraimage?.swing0} alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.greeniron?.iron1?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.greeniron?.preferred_club === "1" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">2</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.greeniron?.iron2?.cameraimage?.swing0} alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.greeniron?.iron2?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }}
                                                                />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.greeniron?.preferred_club === "2" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>

                                            <div className="three-image col-4 d-flex flex-column align-items-center" style={{ position: 'relative' }}>
                                                {
                                                    studio_fitting ? <div className="image-placeholder">
                                                        <h3 className="placeholder-text">3</h3>
                                                    </div>
                                                        : (
                                                            <div className="image-box">
                                                                <img src={API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.greeniron?.iron3?.cameraimage?.swing0} alt="img"
                                                                    onClick={() => handleShowLightBox(API_URL + "remotefittingimage/" + remortFittingimages?.irondata?.greeniron?.iron3?.cameraimage?.swing0)}
                                                                    style={{ height: '100%', width: '100%', objectFit: 'cover', borderRadius: '10%' }} />
                                                            </div>
                                                        )}
                                                <div className="heart-container">
                                                    <FaHeart
                                                        color={heartdata?.irondata?.greeniron?.preferred_club === "3" ? '#82bf2a' : '#fff'}
                                                        className="heart-icon"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    )}

                                {
                                    remortFittingFormData?.fitting_type !== "appfitting" ? (<div className="row gx-2">
                                        <div className="col-6 form-group align-self-center" controlid="validationCustom01">
                                            <h3 style={{ color: "#ffffff" }}>Swing Weight</h3>
                                        </div>
                                        <div className="col-12 col-md-6 form-group" controlid="validationCustom01">
                                            <select class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                value={prescription?.swingWeightdropdownselect} required
                                                disabled={isDropdownDisabled()}
                                                onChange={(e) => handleSelectChange('swingWeightdropdownselect', e.target.value)}>
                                                <option value={""}>Select Swing Weight</option>
                                                <option value="1">Heavy</option>
                                                <option value="2">Medium</option>
                                                <option value="3">Light</option>
                                            </select>
                                            <Form.Control.Feedback type="invalid">
                                                Please select a Dexterity
                                            </Form.Control.Feedback>
                                        </div>

                                    </div>) : (<div className="row default-row">
                                        <div className='col-12 col-md-6 d-flex align-items-center gap-3'>
                                            <div className="form-group align-self-center mb-0" controlid="validationCustom01" style={{ width: "fit-content" }}>
                                                <h3 className="d-flex mb-0" style={{ color: "#ffffff", minWidth: "max-content" }}>Swing Weight</h3>
                                            </div>
                                            <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                <select disabled={isDropdownDisabled()} class="form-select form-control dashboard-input-box-3 select-custom-boxx" aria-label="Default select example"
                                                    value={prescription?.swingWeightdropdownselect}
                                                    onChange={(e) => handleSelectChange('swingWeightdropdownselect', e.target.value)}>
                                                    <option value={""}>Select Swing Weight</option>
                                                    <option value="1">Heavy</option>
                                                    <option value="2">Medium</option>
                                                    <option value="3">Light</option>
                                                </select>
                                                <Form.Control.Feedback type="invalid">
                                                    Please select a Dexterity
                                                </Form.Control.Feedback>
                                            </div>
                                        </div>


                                        {/* Label column */}
                                        <div className="col-12 col-md-6 d-flex align-items-center gap-3" controlid="validationCustom01">
                                            <h3 style={{ color: "#ffffff", width: "fit-content", marginBottom: "0px" }}>Preferred</h3>

                                            {/* Dropdown select column */}
                                            <div className="form-group mb-0" controlid="validationCustom01" style={{ width: "100%" }}>
                                                <select
                                                    disabled={isDropdownDisabled()} // Disable condition
                                                    className="form-select form-control dashboard-input-box-3 select-custom-boxx"
                                                    aria-label="Image select dropdown"
                                                >
                                                    <option value="">Select Preferred</option>
                                                    {/* Map over image options to populate dropdown */}
                                                    {imageOptions.map((option, index) => (
                                                        <option key={index} value={option.value}>
                                                            {option.label}
                                                        </option>
                                                    ))}
                                                </select>

                                                {/* Validation feedback */}
                                                <Form.Control.Feedback type="invalid">
                                                    Please select an image
                                                </Form.Control.Feedback>
                                            </div>
                                        </div>
                                    </div>)
                                }

                                <textarea disabled={isDropdownDisabled()} required className="dashboard-text-area" id="exampleFormControlTextarea1" value={prescription?.swingWeight} onChange={(e) => handleChange('swingWeight', e.target.value)} rows="10" placeholder="Add swing weight notes..." ></textarea>
                                <Form.Control.Feedback type="invalid">
                                    Please provide a valid swing weight.
                                </Form.Control.Feedback>
                            </div>
                        </div>

                        {
                            remortFittingFormData?.fitting_type === "appfitting" && (<PrescriptionDataPoints colorType="Green" appdata={remortFittingFormData?.app_data?.Green} imageURL={imageURL} shotStats={shotStats} />)
                        }
                    </div >
                    <div className="btn-box-section btn-inline-box" >

                        <>
                            {
                                fittingid === null || fittingid === undefined || fittingid === ""
                                    ? (
                                        <button disabled={isDropdownDisabled()} className="btn btn-primary btn-create" type='submit'>
                                            {apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Save Project</span>)}
                                        </button>
                                    )
                                    : (
                                        <button disabled={isDropdownDisabled()} className="btn btn-primary btn-create" type='submit'>
                                            {apicall ? (<Spinner animation="border" className="border-black" />) : (<span>Update Project</span>)}
                                        </button>
                                    )
                            }
                        </>

                    </div>
                </Form >
            </div >
            <style>
                {`.video-container1 {
              position: relative;
              width: 100%;
              height: 600px;
              background-position: center top;
            }
            .video-container2 {
              position: relative;
              width: 100%;
              height: 600px;
              background-position: center top;
            }
            
            .card-videoo{
            width: 100%;
            height: 100%;}
            
            @media only screen and (min-width: 280px) and (max-width: 480px) {
                .video-container1, .video-container2 {
                    height: 80vw;
                }
            }
            
            @media only screen and (min-width: 481px) and (max-width: 767px) {
                .video-container1, .video-container2  {
                    height: 75vw;
                }
            }
            
            @media only screen and (min-width: 768px) and (max-width: 990px) {
                .video-container1, .video-container2  {
                    height: 580px;
                    background-position: center center;
                }
            }
            @media only screen and (min-width: 991px) and (max-width: 1270px) {
                .video-container1, .video-container2  {
                    height: 450px;
                    background-position: center;
                }
            }
            @media only screen and (min-width: 1271px) and (max-width: 1600px) {
              .video-container1, .video-container2  {
                height: 540px;
                background-position: center ;
              }
            }
            @media only screen and (min-width: 1601px) and (max-width: 1900px) {
              .video-container1, .video-container2  {
                height: 70vh;
                background-position: center ;
              }
            }
            @media only screen and (min-width: 1901px) and (max-width: 2499px) {
              .video-container1, .video-container2  {
                height: 75vh;
                background-position: center ;
              }
            }
            @media only screen and (min-width: 2500px) {
              .video-container1, .video-container2  {
                height: 80vh;
                background-position: center ;
                } 
            }
              video {
              width: 100%;
              height: 100%;
            //   outline: 0.1px solid rgb(73, 73, 73);
              border-radius: .5rem; 
            }
            
            
            .image-row-container {
              display: flex;
              gap: 10px;
              justify-content: space-around;
              flex-wrap: nowrap;
            }
            
            /* Ensure each image container is a perfect square */
            .image-box {
              width: 200px; /* Set a fixed size */
              height: 200px;
              overflow: hidden;
              border-radius: 10%;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            
            /* Ensure images are square and cover the container */
            .square-image {
              width: 100%;
              height: 100%;
              object-fit: cover;
              border-radius: 10%;
            }
            
            /* Styling for placeholders when studio fitting is true */
            .image-placeholder {
              width: 150px;
              height: 150px;
              border-radius: 15px;
              background-color: #41464f;
              display: flex;
              align-items: center;
              justify-content: center;
            }
            
            .placeholder-text {
              color: #ffffff;
              font-weight: bold;
              font-size: 24px;
            }
            
            
            
            `}
            </style>
        </>


    );

}

export default LeftScript4;